export const featuresData: any = {
  value: [
    {
      category: 'Data',
      features: [
        {
          value: 'North American Routing Database',
          standard: 1,
          premium: 1,
        },
        {
          value: 'U.S. ZIP Codes',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Canadian & Mexican Postal Codes',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Standard Point Location Codes (SPLC)',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Toll Costs by Vehicle Type',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Predictive Traffic Speeds',
          standard: 0,
          premium: 1,
        },
      ],
    },
    {
      category: 'Routing Options',
      features: [
        {
          value: 'Multi-Stop Routing',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Truck-Specific Routing',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Light Vehicle Routing',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Practical Routing',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Shortest Routing',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Fastest Routing',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Hub Routing',
          standard: 1,
          premium: 1,
        },
        {
          value: 'National Network Routing',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Toll Discouraged Routing',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Borders Open/Closed Routing',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Override Truck Restrictions',
          standard: 1,
          premium: 1,
        },
        {
          value: 'By-Route Greenhouse Gas Estimator',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Set Default Routing Options',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Save Routes',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Duplicate Routes',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Define Departure or Arrival Date/Time',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Set Governor (Maximum) Speed',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Multi-Stop Route Resequencing',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Elevation Discouraged Routing',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Add Stops with Single Search Field',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Import Stops from File',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Vehicle Dimensions Routing',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Street-Level Routing in U.S. and Canada',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Hazardous Materials Routing',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Input of Stop Durations',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Save Favorite Places',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Drag-and-drop Routing',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Route Modifiers',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Site Routing with Entry/Exit Gates',
          standard: 0,
          premium: 1,
        },
      ],
    },
    {
      category: 'Reporting',
      features: [
        {
          value: 'State/Country Distance Report',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Summary by Road Type Report',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Driving Directions Report',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Detailed Route Reports',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Customized Route Costs',
          standard: 0,
          premium: 1,
        },
      ],
    },
    {
      category: 'Mapping',
      features: [
        {
          value: 'Multiple Map Styles, including Satellite Imagery',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Route Display',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Real-Time Traffic Display',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Real-Time Weather Information',
          standard: 0,
          premium: 1,
        },
      ],
    },
    {
      category: 'Services',
      features: [
        {
          value: 'Hosted in Data Center',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Annual Updates',
          standard: 1,
          premium: 1,
        },
        {
          value: 'Map and Toll Data Updates',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Multiple Version Support (Reports Only)',
          standard: 0,
          premium: 1,
        },
        {
          value: 'Live Chat',
          standard: 0,
          premium: 1,
        },
      ],
    },
  ],
};
